import useTranslation from '../../hooks/useTranslation';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { create } from './table-schema';
import timeFormAPI from '../../api/ui/timeFormAPI';

function useSchemaStoredPowerLog() {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.language.locale);

  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    "admin.log.perplay.storedPower.table.head.logNo", // "로그 번호",
    "admin.log.perplay.storedPower.table.head.accountNo", // "유저 ID",
    "admin.log.perplay.storedPower.table.head.nftUid", // "NFT UID",
    "admin.log.perplay.storedPower.table.head.contentNo", // "CONTENT NO",
    "admin.log.perplay.storedPower.table.head.beforeStoredPower", // "이전 저장 파워",
    "admin.log.perplay.storedPower.table.head.afterStoredPower", // "이후 저장 파워",
    "admin.log.perplay.storedPower.table.head.maxStoredPower", // "최대 저장량",
    "admin.log.perplay.storedPower.table.head.addedMaxStoredPowerEndAt", // "최대 저장량 증가 만료 시각",
    "admin.log.perplay.storedPower.table.head.createdAt", // "실행 시각",
  ];

  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   *
   * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
   *
   * param1은 헤더의 첫번째 표시되는 항목이다.
   *
   * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
   *
   * key는 반드시 있어야 한다.
   * @param {object} row
   * @returns
   */
  const parse = (row) => {
    const logNo = row?.logNo;
    const accountNo = row?.accountNo;
    const nftUid = row?.nftUid;
    const contentNo = row?.contentNo;
    const beforeStoredPower = row?.beforeStoredPower;
    const afterStoredPower = row?.afterStoredPower;
    const maxStoredPower = row?.maxStoredPower;
    const addedMaxStoredPowerEndAt = timeFormAPI.changeDataLog(row?.addedMaxStoredPowerEndAt);
    const createdAt = timeFormAPI.changeDataLog(row?.createdAt);

    return {
      key: logNo,
      param1: logNo,
      param2: accountNo,
      param3: nftUid,
      param4: contentNo,
      param5: beforeStoredPower,
      param6: afterStoredPower,
      param7: maxStoredPower,
      param8: addedMaxStoredPowerEndAt,
      param9: createdAt,
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys.map((key) => t(key));
    const schema = create({
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaStoredPowerLog;
